import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const updateCampaign = async (domain: string, campaignId: number, nextIsActive: boolean): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `campaigns/${campaignId}`,
        method: 'PATCH',
        params: {
            nextIsActive,
        },
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}